import React, { useState, useEffect } from 'react';
import {
  useParams, useLocation, Link, ScrollRestoration,
} from 'react-router-dom';
import { Button, Tabs, Tab } from 'react-bootstrap5';

import routes from 'app/routes';
import PermissionsGate from 'components/Users/PermissionsGate';
import { ContextProvider as MembersContextProvider } from 'components/Managers/Members/Context';
import { useContext as useTeamsContext } from 'components/Managers/Teams/Context';
import { useContext } from 'components/Managers/Programs/Context';
import useTemplate from 'components/Managers/Templates/utils/useTemplate';
import MembersTable from './MembersTable';
import TeamsTable from './TeamsTable';
import MembersModal from './MembersModal';

export default function Index() {
  const { dispatch: dispatchTeams, actions: actionsTeams } = useTeamsContext();
  const { state } = useContext();
  const [showModal, setShowModal] = useState(false);
  const { templateId } = useParams();
  const stateLocation = useLocation();
  const template = stateLocation.template || useTemplate(templateId);

  useEffect(() => {
    actionsTeams.load(dispatchTeams);
  }, []);

  return (
    <MembersContextProvider enterpriseId={state.enterpriseId}>
      <div className="content">
        <section>
          <h1 className="mb-3">Assign Members</h1>

          <h3>{template && template.attributes.title}</h3>

          <p className="mb-5">
            Select individual members to assign to this program.
            Additionally, you can also choose to add whole teams of employees to the program.
          </p>

          <Tabs
            defaultActiveKey="members"
            id="programs-assign-tables"
            justify
          >
            <Tab eventKey="members" title="Members">
              <MembersTable />
            </Tab>

            <Tab eventKey="teams" title="Teams">
              <TeamsTable />
            </Tab>
          </Tabs>
        </section>

        <footer className="d-md-flex flex-row-reverse">
          <PermissionsGate scopes={{ 'Assign Programs to Members': ['edit'] }}>
            <div className="mb-3 mb-md-0 ms-md-3">
              <Button
                onClick={() => setShowModal(true)}
                className="w-100"
                disabled={state.selectedMembers.length === 0}
              >
                Assign
              </Button>
            </div>
          </PermissionsGate>

          <div className="flex-grow-1 d-flex justify-content-between justify-content-md-end">
            <Link
              to={routes.managers.programs.index}
              className="btn btn-outline-primary"
            >
              Cancel
            </Link>

            <a
              href={routes.managers.invite.index}
              className="btn btn-outline-primary btn-reverse"
            >
              Invite Members
            </a>
          </div>
        </footer>

        <MembersModal
          show={showModal}
          templateTitle={template ? template.attributes.title : ''}
          onCloseClick={() => setShowModal(false)}
        />

        <ScrollRestoration />
      </div>
    </MembersContextProvider>
  );
}
